import React, { useState } from 'react';
import './Common.css';
import { apiService } from '../api/api';
import { Check } from 'lucide-react';

// ─── International Phone Validation (same as ProfilePage) ────────────────────
const COUNTRY_PHONE_RULES = [
  { code: '+1',   iso: 'US',  name: 'USA / Canada',maxLen: 12, pattern: /^\+1[2-9]\d{2}[2-9]\d{6}$/,               digits: '10 digits after +1',     example: '+12025551234' },
  { code: '+91',  iso: 'IN',  name: 'India',        maxLen: 13, pattern: /^\+91[6-9]\d{9}$/,                         digits: '10 digits after +91',    example: '+919876543210' },
  { code: '+86',  iso: 'CN',  name: 'China',        maxLen: 14, pattern: /^\+86(13|14|15|16|17|18|19)\d{9}$/,        digits: '11 digits after +86',    example: '+8613812345678' },
  { code: '+81',  iso: 'JP',  name: 'Japan',        maxLen: 13, pattern: /^\+81[789]0\d{8}$/,                        digits: '10-11 digits after +81', example: '+819012345678' },
  { code: '+82',  iso: 'KR',  name: 'South Korea',  maxLen: 13, pattern: /^\+821[0-9]\d{7,8}$/,                      digits: '9-10 digits after +82',  example: '+821012345678' },
  { code: '+65',  iso: 'SG',  name: 'Singapore',    maxLen: 11, pattern: /^\+65[689]\d{7}$/,                         digits: '8 digits after +65',     example: '+6591234567' },
  { code: '+60',  iso: 'MY',  name: 'Malaysia',     maxLen: 13, pattern: /^\+601[0-9]\d{7,8}$/,                      digits: '9-10 digits after +60',  example: '+60123456789' },
  { code: '+66',  iso: 'TH',  name: 'Thailand',     maxLen: 12, pattern: /^\+66[689]\d{8}$/,                         digits: '9 digits after +66',     example: '+66812345678' },
  { code: '+63',  iso: 'PH',  name: 'Philippines',  maxLen: 13, pattern: /^\+639\d{9}$/,                             digits: '10 digits after +63',    example: '+639171234567' },
  { code: '+62',  iso: 'ID',  name: 'Indonesia',    maxLen: 15, pattern: /^\+628\d{8,11}$/,                          digits: '9-12 digits after +62',  example: '+62812345678' },
  { code: '+92',  iso: 'PK',  name: 'Pakistan',     maxLen: 13, pattern: /^\+923\d{9}$/,                             digits: '10 digits after +92',    example: '+923001234567' },
  { code: '+880', iso: 'BD',  name: 'Bangladesh',   maxLen: 14, pattern: /^\+8801[3-9]\d{8}$/,                       digits: '10 digits after +880',   example: '+8801712345678' },
  { code: '+971', iso: 'AE',  name: 'UAE',          maxLen: 13, pattern: /^\+9715\d{8}$/,                            digits: '9 digits after +971',    example: '+971501234567' },
  { code: '+966', iso: 'SA',  name: 'Saudi Arabia', maxLen: 13, pattern: /^\+9665\d{8}$/,                            digits: '9 digits after +966',    example: '+966512345678' },
  { code: '+974', iso: 'QA',  name: 'Qatar',        maxLen: 12, pattern: /^\+974[3-7]\d{7}$/,                        digits: '8 digits after +974',    example: '+97430123456' },
  { code: '+973', iso: 'BH',  name: 'Bahrain',      maxLen: 12, pattern: /^\+973[3-9]\d{7}$/,                        digits: '8 digits after +973',    example: '+97333123456' },
  { code: '+968', iso: 'OM',  name: 'Oman',         maxLen: 12, pattern: /^\+9689\d{7}$/,                            digits: '8 digits after +968',    example: '+96891234567' },
  { code: '+972', iso: 'IL',  name: 'Israel',       maxLen: 13, pattern: /^\+9725\d{8}$/,                            digits: '9 digits after +972',    example: '+972501234567' },
  { code: '+44',  iso: 'GB',  name: 'UK',           maxLen: 13, pattern: /^\+447\d{9}$/,                             digits: '10 digits after +44',    example: '+447911123456' },
  { code: '+49',  iso: 'DE',  name: 'Germany',      maxLen: 15, pattern: /^\+491[567]\d{8,10}$/,                     digits: '10-12 digits after +49', example: '+4915123456789' },
  { code: '+33',  iso: 'FR',  name: 'France',       maxLen: 12, pattern: /^\+33[67]\d{8}$/,                          digits: '9 digits after +33',     example: '+33612345678' },
  { code: '+39',  iso: 'IT',  name: 'Italy',        maxLen: 13, pattern: /^\+393\d{9}$/,                             digits: '10 digits after +39',    example: '+393123456789' },
  { code: '+34',  iso: 'ES',  name: 'Spain',        maxLen: 12, pattern: /^\+346\d{8}$/,                             digits: '9 digits after +34',     example: '+34612345678' },
  { code: '+31',  iso: 'NL',  name: 'Netherlands',  maxLen: 12, pattern: /^\+316\d{8}$/,                             digits: '9 digits after +31',     example: '+31612345678' },
  { code: '+41',  iso: 'CH',  name: 'Switzerland',  maxLen: 12, pattern: /^\+417[6-9]\d{7}$/,                        digits: '9 digits after +41',     example: '+41761234567' },
  { code: '+43',  iso: 'AT',  name: 'Austria',      maxLen: 14, pattern: /^\+436\d{8,10}$/,                          digits: '9-11 digits after +43',  example: '+436641234567' },
  { code: '+32',  iso: 'BE',  name: 'Belgium',      maxLen: 12, pattern: /^\+324\d{8}$/,                             digits: '9 digits after +32',     example: '+32412345678' },
  { code: '+47',  iso: 'NO',  name: 'Norway',       maxLen: 11, pattern: /^\+474\d{7}$/,                             digits: '8 digits after +47',     example: '+4741234567' },
  { code: '+46',  iso: 'SE',  name: 'Sweden',       maxLen: 12, pattern: /^\+467\d{8}$/,                             digits: '9 digits after +46',     example: '+46701234567' },
  { code: '+45',  iso: 'DK',  name: 'Denmark',      maxLen: 11, pattern: /^\+454\d{7}$/,                             digits: '8 digits after +45',     example: '+4541234567' },
  { code: '+358', iso: 'FI',  name: 'Finland',      maxLen: 14, pattern: /^\+3584\d{7,8}$/,                          digits: '8-9 digits after +358',  example: '+358412345678' },
  { code: '+48',  iso: 'PL',  name: 'Poland',       maxLen: 12, pattern: /^\+48[4-9]\d{8}$/,                         digits: '9 digits after +48',     example: '+48512345678' },
  { code: '+7',   iso: 'RU',  name: 'Russia',       maxLen: 12, pattern: /^\+7[789]\d{9}$/,                          digits: '10 digits after +7',     example: '+79161234567' },
  { code: '+380', iso: 'UA',  name: 'Ukraine',      maxLen: 13, pattern: /^\+380[3-9]\d{8}$/,                        digits: '9 digits after +380',    example: '+380501234567' },
  { code: '+30',  iso: 'GR',  name: 'Greece',       maxLen: 13, pattern: /^\+306\d{9}$/,                             digits: '10 digits after +30',    example: '+306901234567' },
  { code: '+351', iso: 'PT',  name: 'Portugal',     maxLen: 13, pattern: /^\+3519\d{8}$/,                            digits: '9 digits after +351',    example: '+351912345678' },
  { code: '+36',  iso: 'HU',  name: 'Hungary',      maxLen: 13, pattern: /^\+36[237]\d{7,8}$/,                       digits: '8-9 digits after +36',   example: '+36201234567' },
  { code: '+420', iso: 'CZ',  name: 'Czech Republic', maxLen: 13, pattern: /^\+420[6-7]\d{8}$/,                        digits: '9 digits after +420',    example: '+420601234567' },
  { code: '+40',  iso: 'RO',  name: 'Romania',      maxLen: 12, pattern: /^\+407\d{8}$/,                             digits: '9 digits after +40',     example: '+40712345678' },
  { code: '+55',  iso: 'BR',  name: 'Brazil',       maxLen: 14, pattern: /^\+55[1-9][1-9]\d{8,9}$/,                  digits: '10-11 digits after +55', example: '+5511912345678' },
  { code: '+52',  iso: 'MX',  name: 'Mexico',       maxLen: 14, pattern: /^\+521\d{10}$/,                            digits: '10 digits after +52',    example: '+5215512345678' },
  { code: '+54',  iso: 'AR',  name: 'Argentina',    maxLen: 14, pattern: /^\+549\d{10}$/,                            digits: '10 digits after +54',    example: '+5491112345678' },
  { code: '+56',  iso: 'CL',  name: 'Chile',        maxLen: 12, pattern: /^\+569\d{8}$/,                             digits: '9 digits after +56',     example: '+56912345678' },
  { code: '+57',  iso: 'CO',  name: 'Colombia',     maxLen: 13, pattern: /^\+573\d{9}$/,                             digits: '10 digits after +57',    example: '+573001234567' },
  { code: '+27',  iso: 'ZA',  name: 'South Africa', maxLen: 12, pattern: /^\+276\d{8}$/,                             digits: '9 digits after +27',     example: '+27612345678' },
  { code: '+234', iso: 'NG',  name: 'Nigeria',      maxLen: 14, pattern: /^\+2347\d{9}$/,                            digits: '10 digits after +234',   example: '+2347012345678' },
  { code: '+20',  iso: 'EG',  name: 'Egypt',        maxLen: 13, pattern: /^\+201[0125]\d{8}$/,                       digits: '10 digits after +20',    example: '+201012345678' },
  { code: '+254', iso: 'KE',  name: 'Kenya',        maxLen: 13, pattern: /^\+2547\d{8}$/,                            digits: '9 digits after +254',    example: '+254712345678' },
  { code: '+61',  iso: 'AU',  name: 'Australia',    maxLen: 12, pattern: /^\+614\d{8}$/,                             digits: '9 digits after +61',     example: '+61412345678' },
  { code: '+64',  iso: 'NZ',  name: 'New Zealand',  maxLen: 13, pattern: /^\+642\d{7,9}$/,                           digits: '8-10 digits after +64',  example: '+6421234567' },
];

const detectCountryRule = (phone) => {
  if (!phone || !phone.startsWith('+')) return null;
  const sorted = [...COUNTRY_PHONE_RULES].sort((a, b) => b.code.length - a.code.length);
  return sorted.find(r => phone.startsWith(r.code)) || null;
};

const validatePhoneNumber = (phone) => {
  if (!phone || !phone.trim()) return { valid: false, message: 'Phone number is required' };
  const cleaned = phone.replace(/[\s\-().]/g, '');
  if (!cleaned.startsWith('+')) {
    return { valid: false, message: 'Phone must start with a country code (e.g. +1 for USA, +91 for India)' };
  }
  const rule = detectCountryRule(cleaned);
  if (!rule) {
    const genericPattern = /^\+\d{1,4}\d{6,12}$/;
    if (!genericPattern.test(cleaned)) {
      return { valid: false, message: 'Invalid phone number. Use format: +[country code][number] (e.g. +12025551234)' };
    }
    return { valid: true, message: '', country: null };
  }
  if (!rule.pattern.test(cleaned)) {
    return { valid: false, message: `Invalid ${rule.name} number. Format: ${rule.digits} (e.g. ${rule.example})`, country: rule };
  }
  return { valid: true, message: '', country: rule };
};

// ─── Smart Phone Input (same as ProfilePage) ─────────────────────────────────
const SmartPhoneInput = ({
  value = '',
  onChange,
  onBlur,
  error,
  disabled = false,
  name = 'phoneNumber',
  placeholder,
  inputStyle = {},
}) => {
  const cleaned   = value.replace(/[\s\-().]/g, '');
  const detected  = detectCountryRule(cleaned);

  const digitsTyped   = cleaned.replace(/^\+/, '').replace(/\D/g, '').length;
  const maxCleanLen   = detected ? detected.maxLen : null;
  const maxDigits     = maxCleanLen ? maxCleanLen - 1 : null;
  const isAtMax       = maxDigits !== null && digitsTyped >= maxDigits;
  const isOverMax     = maxDigits !== null && digitsTyped > maxDigits;
  const isValidNow    = detected && validatePhoneNumber(value).valid;

  const borderColor = error
    ? '#ea4335'
    : isOverMax
      ? '#ea4335'
      : isValidNow
        ? '#16a34a'
        : '#e0e0e0';

  const ALLOWED = /^[+\d\s\-().]*$/;

  const emit = (newVal) => {
    if (typeof onChange === 'function') {
      onChange({ target: { name, value: newVal } });
    }
  };

  const handleKeyDown = (e) => {
    if (
      ['Backspace','Delete','Tab','Enter',
       'ArrowLeft','ArrowRight','ArrowUp','ArrowDown',
       'Home','End'].includes(e.key) || e.ctrlKey || e.metaKey
    ) return;

    if (e.key === '+') {
      if (e.target.selectionStart !== 0 || value.includes('+')) {
        e.preventDefault(); return;
      }
    }

    if (!/[\d\s\-().]/.test(e.key) && e.key !== '+') {
      e.preventDefault(); return;
    }

    if (/\d/.test(e.key) && maxDigits !== null) {
      const selectedDigits = value
        .slice(e.target.selectionStart, e.target.selectionEnd)
        .replace(/\D/g, '').length;
      const netNewDigits = 1 - selectedDigits;
      if (digitsTyped + netNewDigits > maxDigits) {
        e.preventDefault(); return;
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    let pasted = e.clipboardData.getData('text').replace(/[^+\d\s\-().]/g, '');
    const hasPlus = pasted.includes('+');
    pasted = pasted.replace(/\+/g, '');
    if (hasPlus) pasted = '+' + pasted;

    const { selectionStart: s, selectionEnd: en } = e.target;
    let newVal = value.slice(0, s) + pasted + value.slice(en);

    const newCleaned = newVal.replace(/[\s\-().]/g, '');
    const rule = detectCountryRule(newCleaned);
    if (rule) {
      newVal = newCleaned.slice(0, rule.maxLen);
    }

    emit(newVal);
  };

  const handleChange = (e) => {
    let val = e.target.value;

    if (!ALLOWED.test(val)) val = val.replace(/[^+\d\s\-().]/g, '');

    if (val.indexOf('+') > 0 || (val.split('+').length - 1) > 1) {
      val = '+' + val.replace(/\+/g, '');
    }

    const valCleaned = val.replace(/[\s\-().]/g, '');
    const rule = detectCountryRule(valCleaned);
    if (rule && valCleaned.length > rule.maxLen) {
      val = valCleaned.slice(0, rule.maxLen);
    }

    emit(val);
  };

  const counterText  = maxDigits !== null ? `${digitsTyped} / ${maxDigits}` : null;
  const counterColor = isOverMax ? '#ea4335' : isAtMax && isValidNow ? '#16a34a' : '#9ca3af';

  return (
    <div>
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
        {detected && (
          <div style={{
            position: 'absolute', left: 0, top: 0, bottom: 0,
            display: 'flex', alignItems: 'center', gap: 4,
            padding: '0 10px',
            background: '#f1f5f9',
            borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px',
            borderRight: `1.5px solid ${borderColor}`,
            pointerEvents: 'none', zIndex: 2, whiteSpace: 'nowrap',
            minWidth: 58,
          }}>
            <span style={{ fontSize: 16, lineHeight: 1 }}>{detected.flag}</span>
            <span style={{ fontSize: 12, fontWeight: 700, color: '#475569', letterSpacing: '0.5px' }}>
              {detected.iso}
            </span>
          </div>
        )}

        <input
          type="tel"
          name={name}
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onPaste={handlePaste}
          onBlur={onBlur}
          disabled={disabled}
          placeholder={placeholder || '+1 202 555 1234  ·  +91 98765 43210  ·  +44 7911 123456'}
          style={{
            width: '100%',
            padding: `11px ${counterText ? '60px' : '14px'} 11px ${detected ? '70px' : '14px'}`,
            borderRadius: '8px',
            border: `1.5px solid ${borderColor}`,
            fontSize: '14px',
            outline: 'none',
            boxSizing: 'border-box',
            transition: 'border-color 0.2s',
            backgroundColor: disabled ? '#f8f9fa' : '#fff',
            color: disabled ? '#666' : '#1e293b',
            cursor: disabled ? 'not-allowed' : 'text',
            fontFamily: 'inherit',
            ...inputStyle,
          }}
          onFocus={e => { if (!disabled) e.target.style.borderColor = error ? '#ea4335' : '#018d71'; }}
        />

        {counterText && !disabled && (
          <span style={{
            position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
            fontSize: 11, fontWeight: 700, color: counterColor,
            pointerEvents: 'none', userSelect: 'none',
          }}>
            {counterText}
          </span>
        )}
      </div>

      {!disabled && (() => {
        if (detected && isValidNow && !error)
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginTop: 5, fontSize: 11, color: '#16a34a', fontWeight: 600 }}>
              <Check size={11} /> {detected.flag} {detected.name} · Valid number
            </div>
          );
        if (detected && isOverMax)
          return (
            <div style={{ marginTop: 5, fontSize: 11, color: '#ea4335', fontWeight: 600 }}>
              ⚠️ Too many digits for {detected.name} ({detected.digits})
            </div>
          );
        if (detected && !isValidNow && !error && value.length > detected.code.length)
          return (
            <div style={{ marginTop: 5, fontSize: 11, color: '#6b7280' }}>
              {detected.flag} {detected.name} · {detected.digits} · e.g. {detected.example}
            </div>
          );
        if (!detected && value && value.startsWith('+') && !error)
          return (
            <div style={{ marginTop: 5, fontSize: 11, color: '#6b7280' }}>
              🌍 Examples: +12025551234 (USA) · +919876543210 (India) · +8613812345678 (China) · +447911123456 (UK)
            </div>
          );
        if (!value)
          return (
            <div style={{ marginTop: 5, fontSize: 11, color: '#9ca3af' }}>
              Start with country code · +1 (USA) · +91 (India) · +86 (China) · +44 (UK)
            </div>
          );
        return null;
      })()}
    </div>
  );
};

// ─── Register Page ────────────────────────────────────────────────────────────
// ✅ Registration always assigns roleId: 2 (Customer) — handled in apiService.registerUser

const RegisterPage = ({ onNavigate }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    gender: '',
    phoneNumber: '',
    email: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.fullName) {
      newErrors.fullName = 'Full name is required';
    } else if (formData.fullName.length < 2) {
      newErrors.fullName = 'Name must be at least 2 characters';
    }

    if (!formData.gender) {
      newErrors.gender = 'Gender is required';
    }

    // ✅ Smart international phone validation (same as ProfilePage)
    if (!formData.phoneNumber.trim()) {
      newErrors.phoneNumber = 'Phone number is required';
    } else {
      const phoneResult = validatePhoneNumber(formData.phoneNumber.trim());
      if (!phoneResult.valid) {
        newErrors.phoneNumber = phoneResult.message;
      }
    }

    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);

    try {
      // ── Step 1: Check if email already exists by fetching all users ──────
      // This is the most reliable way since /User/Save may return 200 even for duplicates
      try {
        const allUsers = await apiService.get('/User/GetAll');
        let usersArray = [];
        if (Array.isArray(allUsers)) usersArray = allUsers;
        else if (Array.isArray(allUsers?.data)) usersArray = allUsers.data;
        else if (Array.isArray(allUsers?.users)) usersArray = allUsers.users;

        const emailExists = usersArray.some(
          (u) => u.email?.toLowerCase().trim() === formData.email?.toLowerCase().trim()
        );

        if (emailExists) {
          setErrors({
            email: 'This email address is already registered. Please use a different email or login to your existing account.',
          });
          setLoading(false);
          return;
        }
      } catch (checkErr) {
        // If we can't fetch users (permissions etc.), proceed to register and handle error below
        console.warn('⚠️ Could not pre-check email, proceeding with registration:', checkErr.message);
      }

      // ── Step 2: Register the user ─────────────────────────────────────────
      const response = await apiService.registerUser(formData);
      // console.log('✅ Registration successful:', response);

      alert('Registration successful! You can now log in.');
      setFormData({ fullName: '', gender: '', phoneNumber: '', email: '' });
      onNavigate('login');

    } catch (error) {
      console.error('❌ Registration error:', error);
      console.error('❌ Status:', error.response?.status);
      console.error('❌ Body:', JSON.stringify(error.response?.data));

      // Treat ANY API error during registration as a likely duplicate email
      // since client-side validation already passed all other checks
      const status = error.response?.status;
      const allText = JSON.stringify(error.response?.data || error.message || '').toLowerCase();

      const looksLikeDuplicate =
        status === 400 ||
        status === 409 ||
        status === 422 ||
        allText.includes('email') ||
        allText.includes('exist') ||
        allText.includes('duplicate') ||
        allText.includes('taken') ||
        allText.includes('register') ||
        allText.includes('conflict');

      if (looksLikeDuplicate) {
        setErrors({
          email: 'This email address is already registered. Please use a different email or login to your existing account.',
        });
      } else if (error.request && !error.response) {
        setErrors({ submit: 'Network error. Please check your connection.' });
      } else {
        setErrors({ submit: 'Something went wrong. Please try again.' });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <h1>Create Account</h1>
            <p>Sign up to get started</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            {errors.submit && (
              <div
                className="error-message"
                style={{ marginBottom: '15px', textAlign: 'center', color: '#e74c3c' }}
              >
                {errors.submit}
              </div>
            )}

            {/* Full Name */}
            <div className="form-group">
              <label htmlFor="fullName">Full Name</label>
              <input
                type="text"
                id="fullName"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                className={`form-control ${errors.fullName ? 'error' : ''}`}
                placeholder="Enter your full name"
              />
              {errors.fullName && <span className="error-message">{errors.fullName}</span>}
            </div>

            {/* Gender */}
            <div className="form-group">
              <label htmlFor="gender">Gender</label>
              <select
                id="gender"
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                className={`form-control ${errors.gender ? 'error' : ''}`}
              >
                <option value="">Select gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
                <option value="prefer-not-to-say">Prefer not to say</option>
              </select>
              {errors.gender && <span className="error-message">{errors.gender}</span>}
            </div>

            {/* ✅ Phone Number — SmartPhoneInput with international validation */}
            <div className="form-group">
              <label htmlFor="phoneNumber">Phone Number</label>
              <SmartPhoneInput
                value={formData.phoneNumber}
                onChange={handleChange}
                onBlur={() => {
                  if (formData.phoneNumber.trim()) {
                    const result = validatePhoneNumber(formData.phoneNumber.trim());
                    if (!result.valid) {
                      setErrors(prev => ({ ...prev, phoneNumber: result.message }));
                    } else {
                      setErrors(prev => ({ ...prev, phoneNumber: '' }));
                    }
                  }
                }}
                error={errors.phoneNumber}
                name="phoneNumber"
              />
              {errors.phoneNumber && (
                <span className="error-message" style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 4 }}>
                  ⚠️ {errors.phoneNumber}
                </span>
              )}
            </div>

            {/* ✅ Email — shows specific "already registered" error inline */}
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={`form-control ${errors.email ? 'error' : ''}`}
                placeholder="Enter your email"
                style={
                  errors.email
                    ? { borderColor: '#e74c3c' }
                    : {}
                }
              />
              {errors.email && (
                <div
                  style={{
                    marginTop: '6px',
                    padding: '10px 12px',
                    backgroundColor: '#fff5f5',
                    border: '1px solid #fca5a5',
                    borderRadius: '6px',
                    fontSize: '13px',
                    color: '#dc2626',
                    fontWeight: 500,
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '8px',
                  }}
                >
                  <span style={{ fontSize: '15px', flexShrink: 0 }}>⚠️</span>
                  <span>
                    {errors.email}
                    {errors.email.includes('already registered') && (
                      <>
                        {' '}
                        <button
                          type="button"
                          onClick={() => onNavigate('login')}
                          style={{
                            background: 'none',
                            border: 'none',
                            padding: 0,
                            color: '#018d71',
                            fontWeight: 700,
                            cursor: 'pointer',
                            textDecoration: 'underline',
                            fontSize: '13px',
                          }}
                        >
                          Login instead?
                        </button>
                      </>
                    )}
                  </span>
                </div>
              )}
            </div>

            <button type="submit" className="login-button" disabled={loading}>
              {loading ? 'Creating Account...' : 'Create Account'}
            </button>
          </form>

          <div className="login-footer">
            <p>
              Already have an account?{' '}
              <button
                type="button"
                className="register-link"
                onClick={() => onNavigate('login')}
              >
                Login here
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;